<template>
  <div>
    <vuestic-tabs
      :names="[
        $t('Go-support.ask-inno.title'),
        $t('Go-support.my-tickets.title'),
        $t('Go-support.help-center.title')
      ]"
      ref="tabs"
    >
      <div :slot="$t('Go-support.ask-inno.title')">
        <AskInnoTab />
      </div>
      <div :slot="$t('Go-support.my-tickets.title')">
        <MyTicketsTab />
      </div>
      <div :slot="$t('Go-support.help-center.title')">
        <HelpCenterTab />
      </div>
    </vuestic-tabs>
  </div>
</template>

<script>
import AskInnoTab from './tabs/AskInno'
import HelpCenterTab from './tabs/HelpCenter'
import MyTicketsTab from './tabs/MyTickets'
export default {
  components: {
    AskInnoTab,
    MyTicketsTab,
    HelpCenterTab
  }
}
</script>

<style lang="scss" scoped></style>
